module.exports = __webpack_public_path__ + "img/img1_icon.c75b3d75.png";